import { render, staticRenderFns } from "./OfficeSettings.vue?vue&type=template&id=45914425&scoped=true"
import script from "./OfficeSettings.vue?vue&type=script&lang=js"
export * from "./OfficeSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45914425",
  null
  
)

export default component.exports